export const holidays_observed_2025_2030 = [
  {
    year: 2025,
    newYear: "2025-01-01",
    mlk: "2025-01-20",
    presidents: "2025-02-17",
    memorial: "2025-05-26",
    juneteenth: "2025-06-19",
    independence: "2025-07-04",
    labor: "2025-09-01",
    veterans: "2025-11-11",
    thanksgiving: "2025-11-27",
    christmas: "2025-12-25"
  },
  {
    year: 2026,
    newYear: "2026-01-01",
    mlk: "2026-01-19",
    presidents: "2026-02-16",
    memorial: "2026-05-25",
    juneteenth: "2026-06-19",
    independence: "2026-07-03", // Observed (July 4 is Saturday)
    labor: "2026-09-07",
    veterans: "2026-11-11",
    thanksgiving: "2026-11-26",
    christmas: "2026-12-25"
  },
  {
    year: 2027,
    newYear: "2027-01-01",
    mlk: "2027-01-18",
    presidents: "2027-02-15",
    memorial: "2027-05-31",
    juneteenth: "2027-06-18", // Observed (June 19 is Saturday)
    independence: "2027-07-05", // Observed (July 4 is Sunday)
    labor: "2027-09-06",
    veterans: "2027-11-11",
    thanksgiving: "2027-11-25",
    christmas: "2027-12-24" // Observed (Dec 25 is Saturday)
  },
  {
    year: 2028,
    newYear: "2028-01-03", // Observed (Jan 1 is Saturday)
    mlk: "2028-01-17",
    presidents: "2028-02-21",
    memorial: "2028-05-29",
    juneteenth: "2028-06-19",
    independence: "2028-07-04",
    labor: "2028-09-04",
    veterans: "2028-11-10", // Observed (Nov 11 is Saturday)
    thanksgiving: "2028-11-23",
    christmas: "2028-12-25"
  },
  {
    year: 2029,
    newYear: "2029-01-01",
    mlk: "2029-01-15",
    presidents: "2029-02-19",
    memorial: "2029-05-28",
    juneteenth: "2029-06-19",
    independence: "2029-07-04",
    labor: "2029-09-03",
    veterans: "2029-11-12", // Observed (Nov 11 is Sunday)
    thanksgiving: "2029-11-22",
    christmas: "2029-12-25"
  },
  {
    year: 2030,
    newYear: "2030-01-01",
    mlk: "2030-01-21",
    presidents: "2030-02-18",
    memorial: "2030-05-27",
    juneteenth: "2030-06-19",
    independence: "2030-07-04",
    labor: "2030-09-02",
    veterans: "2030-11-11",
    thanksgiving: "2030-11-28",
    christmas: "2030-12-25"
  }
];
